import {
  FETCH_PROJECT_ACTIVITY_REQUEST,
  FETCH_PROJECT_ACTIVITY_SUCCESS,
  FETCH_PROJECT_ACTIVITY_FAILURE,
  CLEAR_PROJECT_ACTIVITY,
} from './projectActivityLogTypes';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const projectActivityLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROJECT_ACTIVITY_REQUEST:
      return { loading: true, data: null, error: null };
    case FETCH_PROJECT_ACTIVITY_SUCCESS:
      return { loading: false, data: action.payload, error: null };
    case FETCH_PROJECT_ACTIVITY_FAILURE:
      return { loading: false, data: null, error: action.payload };
    case CLEAR_PROJECT_ACTIVITY:
      return initialState;
    default:
      return state;
  }
};

export default projectActivityLogReducer;
